<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  $(document).ready(function(){
    $('.template-product .card-information .product-form__submit')
      .filter(function () {
        return $(this).closest('.product-item-custom').length === 0;
      })
      .text('+');

    const rightElm = document.querySelector('.productView-top .halo-productView-right');
    if (rightElm) {
      const elmHeight = rightElm.getBoundingClientRect().height;
      rightElm.style.setProperty('--data-height', `${elmHeight}px`);
    }
});
